import { render, staticRenderFns } from "./turntableActivities.vue?vue&type=template&id=da06492e&scoped=true"
import script from "./turntableActivities.vue?vue&type=script&lang=js"
export * from "./turntableActivities.vue?vue&type=script&lang=js"
import style0 from "./turntableActivities.vue?vue&type=style&index=0&id=da06492e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da06492e",
  null
  
)

export default component.exports